/**
 * Art forms available for comparison and display
 */
export const ART_FORMS = [
    "Bharatanatyam",
    "Carnatic Music",
    "Kathak",
    "Odissi",
    "Mohiniyattam",
    "Hindustani Classical Music",
    "Indian Sculpture & Architecture",
    "Indian Classical Painting"
];

/**
 * Image paths for various art forms and sections
 */
export const IMAGES = {
    // Main sections
    HERO: '/images/Hero.png',
    BHARATANATYAM: '/images/Bharanatyam_dancer.png',
    CARNATIC_MUSIC: '/images/carnatic_musician.png',
    
    // Other arts
    KATHAK: '/images/Kathak_dancer.png',
    ODISSI: '/images/Odissi_dancer.png',
    MOHINIYATTAM: '/images/Mohiniyattam.png',
    HINDUSTANI_MUSIC: '/images/Hindustani_Music.png',
    INDIAN_SCULPTURE: '/images/Indian_Sculpture.png',
    INDIAN_PAINTING: '/images/Indian_Painting.png',
    
    // Gallery images
    GALLERY: [
        '/images/Gallery_1.png',
        '/images/Gallery_2.png',
        '/images/Gallery_3.png',
        '/images/Gallery_4.png',
        '/images/Gallery_5.png',
        '/images/Gallery_6.png'
    ],

    // Logo
    LOGO: '/images/Logo.jpeg'
};

/**
 * Other arts data with descriptions
 */
export const OTHER_ARTS = [
    {
        image: IMAGES.KATHAK,
        title: "Kathak",
        description: "A major classical dance form of North India, characterized by intricate footwork, spins (chakkar), and storytelling through expressive gestures."
    },
    {
        image: IMAGES.ODISSI,
        title: "Odissi",
        description: "Originating from Odisha, this graceful dance form is known for its sensuous movements, sculpturesque poses (tribhanga), and devotional themes."
    },
    {
        image: IMAGES.MOHINIYATTAM,
        title: "Mohiniyattam",
        description: "A classical dance from Kerala, characterized by its gentle and lyrical movements, often depicting the enchantress Mohini from Hindu mythology."
    },
    {
        image: IMAGES.HINDUSTANI_MUSIC,
        title: "Hindustani Classical Music",
        description: "The classical music tradition of North India, known for its elaborate melodic structures (ragas) and rhythmic patterns (talas), often featuring instruments like sitar, tabla, and harmonium."
    },
    {
        image: IMAGES.INDIAN_SCULPTURE,
        title: "Indian Sculpture & Architecture",
        description: "Explore the diverse and magnificent architectural styles and intricate sculptures found across India, from ancient temples to grand monuments."
    },
    {
        image: IMAGES.INDIAN_PAINTING,
        title: "Indian Classical Painting",
        description: "Discover the rich traditions of Indian painting, including Mughal, Rajput, Pahari, and miniature styles, each with unique narratives and aesthetics."
    }
];
